import { inViewMargin } from '@helpers/animate';
import { imageUrl } from '@helpers/image';
import { useInView } from '@hooks/useInView';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import * as React from 'react';
import S from './SplitContent.styles';
const SplitContent = ({ bgColor = 'white', content, cta, id, image, imageCaption, layout = 'imageLeft', split = '66/33', title, }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    const reducedImage = split === '50/50';
    return (React.createElement(S.Container, { ref: refContainer, id: id, "data-bg": bgColor, "data-inview": inView, "data-layout": layout, "data-split": split },
        React.createElement(S.Inner, null,
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: image.altText, loading: "lazy", src: imageUrl(image, {
                        width: reducedImage ? 802 : 973,
                        height: reducedImage ? 802 : 973,
                        rmode: image.mode,
                    }) }),
                imageCaption && React.createElement(S.ImageCaption, { title: imageCaption }, imageCaption))),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.ContentWrapperInner, null,
                    title && (React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title)),
                    content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                    cta && (React.createElement(S.CtaWrapper, null,
                        React.createElement(LinkButton, { buttonType: "default", href: cta.url, target: cta.target }, cta.text))))))));
};
export default SplitContent;
